import React, { Component } from 'react';
import { Button, Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Carousel.css';

class CarouselList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            direction: null
        }

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(selectedIndex, e) {
        this.setState({
            index: selectedIndex,
            direction: e.direction,
        });
    }

    render () {
        const { projects } = this.props;
        const style = {
            shortDescription: {
                display: 'flex',
                flexFlow: 'row wrap',
                justifyContent: 'center',
                fontSize: '25px',
                color: '#fff',
                paddingBottom: '25px'
            },
            sourceCredit: {
                display: 'flex',
                flexFlow: 'wrap',
                justifyContent: 'flex-end',
                fontSize: '15px',
                color: '#fff',
            }
        }

        return (
            <Carousel activeIndex={this.state.index} direction={this.state.direction} onSelect={this.handleSelect}>
                {projects.map((project) => (
                    <Carousel.Item key={project._id}>
                        <Link to={`/projects/${project.projectId}`}>
                            <img className="tikki-filter" src={project.imageHero} alt="" />
                        </Link>
                        <Carousel.Caption>
                        <p style={style.shortDescription}>{project.shortDescription}</p>
                        <p style={style.sourceCredit}>Image: {project.charity[0].title}, {project.title}</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                ))}
            </Carousel>
        );
    };
};

export default CarouselList;



// WEBPACK FOOTER //
// ./src/components/Carousel/Carousel.js